import React, { useEffect, useState } from "react";
import "../framework.css";

const WalletPoints = () => {
  const [summary, setSummary] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("transactions");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch(process.env.REACT_APP_BASE_URL + "admin/wallet-points", {
      headers: { authorization: token }
    })
      .then(res => res.json())
      .then(data => {
        setSummary(data.summary);
        setTransactions(data.transactions || []);
        setUsers(data.usersWithPoints || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const formatDate = ts => {
    if (!ts) return "-";
    try {
      return new Date(ts).toLocaleString("en-IN", {
        day:"2-digit", month:"short", year:"numeric",
        hour:"2-digit", minute:"2-digit"
      });
    } catch(e) { return "-"; }
  };

  const filteredTx = transactions.filter(t => {
    const q = search.toLowerCase();
    return (
      (t.user?.legalName || "").toLowerCase().includes(q) ||
      (t.user?.phone || "").toLowerCase().includes(q) ||
      (t.transactionDescripion || "").toLowerCase().includes(q)
    );
  });

  const filteredUsers = users.filter(u => {
    const q = search.toLowerCase();
    return (
      (u.legalName || "").toLowerCase().includes(q) ||
      (u.phone || "").toLowerCase().includes(q)
    );
  });

  if (loading) return <div style={{padding:40}}>Loading...</div>;

  return (
    <div style={{padding:24, fontFamily:"sans-serif"}}>
      <h2 style={{marginBottom:24}}>Wallet Points Dashboard</h2>

      {/* Summary Cards */}
      {summary && (
        <div style={{display:"flex", gap:16, marginBottom:32, flexWrap:"wrap"}}>
          {[
            {label:"Total Points Added", value:summary.totalAdded, color:"#28a745"},
            {label:"Total Points Redeemed", value:summary.totalRedeemed, color:"#dc3545"},
            {label:"Net Points Outstanding", value:summary.netPoints, color:"#007bff"},
            {label:"Users with Points", value:summary.usersWithPoints, color:"#fd7e14"},
          ].map(card => (
            <div key={card.label} style={{
              background:"#fff", border:"1px solid #e0e0e0", borderRadius:10,
              padding:"20px 28px", minWidth:180, boxShadow:"0 2px 8px rgba(0,0,0,0.06)"
            }}>
              <div style={{fontSize:13, color:"#888", marginBottom:6}}>{card.label}</div>
              <div style={{fontSize:28, fontWeight:700, color:card.color}}>{card.value?.toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}

      {/* Search */}
      <input
        placeholder="Search by name, phone, description..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{padding:"8px 14px", borderRadius:6, border:"1px solid #ddd", width:320, marginBottom:20, fontSize:14}}
      />

      {/* Tabs */}
      <div style={{display:"flex", gap:8, marginBottom:20}}>
        {["transactions","users"].map(tab => (
          <button key={tab} onClick={() => setActiveTab(tab)} style={{
            padding:"8px 20px", borderRadius:6, border:"none", cursor:"pointer",
            background: activeTab===tab ? "#007bff" : "#f0f0f0",
            color: activeTab===tab ? "#fff" : "#333", fontWeight:600, fontSize:14
          }}>{tab === "transactions" ? "Transaction Logs" : "Users with Points"}</button>
        ))}
      </div>

      {/* Transaction Logs */}
      {activeTab === "transactions" && (
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%", borderCollapse:"collapse", fontSize:13}}>
            <thead>
              <tr style={{background:"#f8f9fa"}}>
                {["Date","User","Phone","Points","Type","Description","Amount"].map(h => (
                  <th key={h} style={{padding:"10px 12px", textAlign:"left", borderBottom:"2px solid #dee2e6", whiteSpace:"nowrap"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredTx.map((t, i) => (
                <tr key={i} style={{borderBottom:"1px solid #f0f0f0", background: i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"8px 12px", whiteSpace:"nowrap"}}>{formatDate(t.transactionDate)}</td>
                  <td style={{padding:"8px 12px"}}>{t.user?.legalName || "-"}</td>
                  <td style={{padding:"8px 12px"}}>{t.user?.phone || "-"}</td>
                  <td style={{padding:"8px 12px", fontWeight:700, color: t.transactionType==="add"?"#28a745":"#dc3545"}}>
                    {t.transactionType==="add"?"+":"-"}{t.points}
                  </td>
                  <td style={{padding:"8px 12px"}}>
                    <span style={{
                      padding:"2px 8px", borderRadius:4, fontSize:11, fontWeight:600,
                      background: t.transactionType==="add"?"#d4edda":"#f8d7da",
                      color: t.transactionType==="add"?"#155724":"#721c24"
                    }}>{t.transactionType}</span>
                  </td>
                  <td style={{padding:"8px 12px"}}>{t.transactionDescripion || "-"}</td>
                  <td style={{padding:"8px 12px"}}>{t.donationAmount ? t.donationAmount + " " + (t.currencyType || "") : "-"}</td>
                </tr>
              ))}
              {filteredTx.length === 0 && (
                <tr><td colSpan={6} style={{padding:20, textAlign:"center", color:"#888"}}>No transactions found</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Users with Points */}
      {activeTab === "users" && (
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%", borderCollapse:"collapse", fontSize:13}}>
            <thead>
              <tr style={{background:"#f8f9fa"}}>
                {["Name","Phone","Email","Wallet Balance","Referred Users"].map(h => (
                  <th key={h} style={{padding:"10px 12px", textAlign:"left", borderBottom:"2px solid #dee2e6"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((u, i) => (
                <tr key={i} style={{borderBottom:"1px solid #f0f0f0", background: i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"8px 12px"}}>{u.legalName || "-"}</td>
                  <td style={{padding:"8px 12px"}}>{u.phone || "-"}</td>
                  <td style={{padding:"8px 12px"}}>{u.email || "-"}</td>
                  <td style={{padding:"8px 12px", fontWeight:700, color:"#007bff"}}>{u.referrInfo?.wallet?.toLocaleString()}</td>
                  <td style={{padding:"8px 12px"}}>{u.referrInfo?.referredUsers?.length || 0}</td>
                </tr>
              ))}
              {filteredUsers.length === 0 && (
                <tr><td colSpan={5} style={{padding:20, textAlign:"center", color:"#888"}}>No users found</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default WalletPoints;
